import { render, staticRenderFns } from "./Prices.vue?vue&type=template&id=a935a002&scoped=true"
import script from "./Prices.vue?vue&type=script&lang=js"
export * from "./Prices.vue?vue&type=script&lang=js"
import style0 from "./Prices.vue?vue&type=style&index=0&id=a935a002&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a935a002",
  null
  
)

export default component.exports